import { useTraduction } from '../i18n/langue';

/**
 * Comment on accède à Repère — les deux cas d'une invitation reçue.
 *
 * Le parent invité et le professionnel arrivent tous deux par un lien, sans avoir rien
 * demandé, et se posent la même question avant de créer un compte : « est-ce que ça va
 * m'engager ou me coûter quelque chose ? » Y répondre **avant** le formulaire supprime
 * l'obstacle que `01-produit.md` §4 identifie comme le principal frein d'adoption.
 *
 * Les faits énoncés viennent de `01-produit.md` §6 et `06-distribution.md` §3 : freemium
 * d'activation, abonnement propre à chaque parent, compte professionnel gratuit. Aucun
 * n'est arrondi dans un sens flatteur — une promesse démentie à la première facture
 * coûterait plus cher que l'inscription gagnée.
 */
export function ModesAcces() {
  const { messages } = useTraduction();
  const m = messages.entree.modesAcces;

  return (
    <section className="entree-acces" aria-labelledby="acces-titre">
      <h2 id="acces-titre">{m.titre}</h2>

      <div className="entree-acces-cas">
        <div>
          <h3>{m.autreParentTitre}</h3>
          <p>{m.autreParentTexte}</p>
        </div>

        <div>
          <h3>{m.proTitre}</h3>
          <p>{m.proTexte}</p>
        </div>
      </div>
    </section>
  );
}
